// start:ng42.barrel
import './transport-confirm-archiving.component';
import './transport-confirm-delete-events.component';
// end:ng42.barrel

